<template>
    <header class="header">
      <!-- ===== 顶部品牌与导航 ===== -->
      <div class="top-nav">
        <div class="logo">
          <h1>数字商机港</h1>
          <span>B2B平台</span>
        </div>
        <div class="nav-menu">
          <router-link to="/" class="active">首页</router-link>
          <a href="#">供应</a>
          <a href="#">求购</a>
          <a href="#">公司</a>
          <a href="#">行情</a>
          <a href="#">资讯</a>
          <a href="#">招商</a>
          <a href="#">展会</a>
          <a href="#">人才</a>
          <a href="#">品牌</a>
        </div>
      </div>
  
      <!-- ===== 搜索区域 ===== -->
      <!-- <div class="search-section">
        <div class="search-box">
          <input type="text" placeholder="搜索产品、公司、供应信息" />
          <button class="btn-search">搜索</button>
        </div>
        <div class="quick-btns">
          <button class="btn-supply">发布供应</button>
          <button class="btn-buy">发布求购</button>
        </div>
      </div> -->
    </header>
  </template>
  
  <script>
  export default {
    name: 'AppHeader'
  }
  </script>
  
  <style scoped>
  .header {
    padding: 20px 0 0;
  }
  
  /* ===== 顶部导航 ===== */
  .top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 2px solid #e8e8e8;
  }
  .logo h1 {
    display: inline-block;
    font-size: 28px;
    color: #c0392b;
  }
  .logo span {
    font-size: 14px;
    color: #666;
    margin-left: 8px;
    font-weight: normal;
  }
  .nav-menu a,
  .nav-menu .router-link-exact-active {
    text-decoration: none;
    color: #333;
    margin: 0 12px;
    font-size: 15px;
    transition: color 0.2s;
  }
  .nav-menu a:hover,
  .nav-menu .router-link-exact-active {
    color: #c0392b;
  }
  .nav-menu .router-link-exact-active {
    font-weight: bold;
  }
  
  /* ===== 搜索区域 ===== */
  .search-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 15px;
  }
  .search-box {
    flex: 1;
    display: flex;
    max-width: 600px;
  }
  .search-box input {
    flex: 1;
    padding: 12px 18px;
    border: 2px solid #e0e0e0;
    border-right: none;
    border-radius: 30px 0 0 30px;
    outline: none;
    font-size: 14px;
    transition: 0.3s;
  }
  .search-box input:focus {
    border-color: #c0392b;
  }
  .search-box .btn-search {
    padding: 12px 30px;
    background: #c0392b;
    color: #fff;
    border: none;
    border-radius: 0 30px 30px 0;
    cursor: pointer;
    font-size: 14px;
    transition: 0.3s;
  }
  .search-box .btn-search:hover {
    background: #a93226;
  }
  .quick-btns button {
    padding: 10px 28px;
    border: 1px solid #c0392b;
    background: transparent;
    color: #c0392b;
    border-radius: 30px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 12px;
    transition: 0.3s;
    font-weight: 500;
  }
  .quick-btns button:hover {
    background: #c0392b;
    color: #fff;
  }
  </style>